'use client';

import { Button } from '@/components/ui/Button';
import { useErrorRetry } from '@/hooks/useErrorRetry';
import { useBoundaryError } from '@/hooks/useBoundaryError';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { retry, isPending } = useErrorRetry();
  useBoundaryError(error, { label: '[GlobalError]' });

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50 p-8">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-slate-800 mb-2">
          Etwas ist schiefgelaufen
        </h2>
        <p className="text-slate-500 mb-6">
          Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.
        </p>
        <Button onClick={retry} loading={isPending} size="lg">Erneut versuchen</Button>
      </div>
    </div>
  );
}
